import React from "react";
import useEventInfo from "gatsby-plugin-hfn-profile/components/PnrSummary/useEventInfo";
import { compareDateWithCurrentDate } from "sites-common/utils/FormatDate";
import { Image } from "theme-ui";

import { StaticImage } from "gatsby-plugin-image";
import appIcons from "sites-common/utils/icons";
import { Accordion } from "react-bootstrap";
import Seo from "../../../../../components/seo";
import Layout from "../../../../../layout";
import "../../../../../assets/styles/special_event.scss";
import SpecialEventBanner from "../../../../../components/special-event/SpecialEventBanner";
import ExploreKanha from "../../../../../components/special-event/ExploreKanha";
import DaajiMessage from "../../../../../components/special-event/DaajiMessage";
import DaajiMessageAudio from "../../../../../components/special-event/DaajiMessageAudio";
import DaajiMessageVideo from "../../../../../components/special-event/DaajiMessageVideo";
import DaajiMessageHtml from "../../../../../components/special-event/DaajiMessageHtml";
import Heartintune from "../../../../../components/special-event/Heartintune";

import {
  bhandaraSept,
  styleProp,
} from "../../../../../assets/data/bandaraRegistration";

const SpecialEventRegistration = () => {
  return (
    <div className="special_event_registration" id="register_event">
      <div className="flower_left">
        <StaticImage
          src="../../../../../../static/special-event/5.png"
          alt="banner"
          placeholder="blurred"
        />
      </div>
      <div className="flower_right">
        <StaticImage
          src="../../../../../../static/special-event/4.png"
          alt="banner"
          placeholder="blurred"
        />
      </div>
      <div className="container">
        <div className="row content_wrapper">
          <div className="col-lg-6 col-md-12">
            <p>Dear ones,</p>
            <p>
              I am delighted to invite you all to join the celebrations for the
              67th birthday of our beloved Pujya Daaji, on 27, 28 and 29
              September 2022 at Kanha Shanti Vanam. Please plan your travel
              accordingly. Details of registration, accommodation, group
              meditation timings and logistics are available on the Heartfulness
              app.
            </p>
            <p>
              You may also start planning any local celebrations in your centers
              accordingly.
            </p>
            <p>
              With love and respect,
              <br />
              <span className="author">Uma Shankar Bajpai </span>
              <br />
              <span className="author">General Secretary </span>
              <br />
              <span className="author">Shri Ram Chandra Mission</span>
            </p>
            <a
              href="https://cdn-prod.heartfulness.org/e-magazines/English/Kanha%20Layout%20Complete%20(3)%20(1).pdf"
              target="_blank"
              rel="noreferrer"
              className="navigation_map"
            >
              Navigation map within Kanha
            </a>
          </div>
          <div className="registerCardWrapper col-lg-5 col-md-12" />
        </div>
      </div>
    </div>
  );
};

const SpecialEvent2 = () => {
  const { customConfig, data } = useEventInfo(bhandaraSept);
  const checkDate = data?.reg_ends
    ? compareDateWithCurrentDate(data.reg_ends)
    : false;

  const staticBannerContent = {
    title: "<h3>Coming together in Kanha</h3>",
    para: "<p>Join us with Daaji to celebrate Chariji`s birth anniversary</p>",
  };

  const bannerContent = customConfig?.bannerContent
    ? { ...staticBannerContent, ...customConfig.bannerContent }
    : staticBannerContent;

  return (
    <>
      <Seo
        title="Free Heartfulness Meditation Event | Daaji | Kanha Shanti Vanam"
        keyword="Heartfulness, Heartfulness Celebrations, Bhandara, Babuji Maharaj Birthday, April Bhandara, Kanha Shantivanam, Kanha Bhandara"
        description="Join Us Live Heartfulness Meditation Event with Daaji to Celebrate Babuji`s Birth Anniversary from Apr 29 to 1 May 2022 at Kanha Shanti Vanam. Register Now!"
      />
      <Layout isSticky wrapperClass="special_event">
        <div>
          <SpecialEventBanner
            eventId={bhandaraSept}
            styleProp={styleProp}
            bannerContent={bannerContent}
            data={data}
          />
          <SpecialEventRegistration
            eventId={bhandaraSept}
            styleProp={styleProp}
            endDate={checkDate}
            data={data}
          />
          {customConfig?.daajiMessage &&
          customConfig?.daajiMessage.length > 0 ? (
            <DaajiMessage eventInfo={customConfig?.daajiMessage || []} />
          ) : (
            <div className="daaji_wrrapper">
              <div className="container">
                <div className="daaji_box">
                  <h2>
                    <span>Daaji&apos;s Message</span>
                  </h2>
                  <div className="text-center">
                    Daaji will release a message during the celebrations that
                    will be available here in many languages.
                  </div>
                </div>
              </div>
            </div>
          )}

          {customConfig?.daajiMessageAudio &&
          customConfig?.daajiMessageAudio.length > 0 ? (
            <DaajiMessageAudio
              eventInfo={customConfig?.daajiMessageAudio || []}
            />
          ) : (
            <div />
          )}

          {customConfig?.daajiMessageVideo &&
          customConfig?.daajiMessageVideo.length > 0 ? (
            <DaajiMessageVideo
              eventInfo={customConfig?.daajiMessageVideo || []}
            />
          ) : (
            <div />
          )}

          {customConfig?.daajiMessageHtml &&
          customConfig?.daajiMessageHtml.length > 0 ? (
            <DaajiMessageHtml
              eventInfo={customConfig?.daajiMessageHtml || []}
            />
          ) : (
            <div />
          )}

          {customConfig?.addToCalendar?.dates &&
            customConfig.addToCalendar?.dates.length > 0 && (
              <div className="calander-wr my-4 pb-4 pt-2">
                <Accordion className="custom-acccordion" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className="accord-custom-head">
                      Add to calendar
                    </Accordion.Header>
                    <Accordion.Body className="text-start">
                      <ul>
                        {customConfig.addToCalendar?.dates.map((item) => (
                          <li className="calander-list">
                            <span className="day-wr">
                              {item?.day}
                              <span className="date-wr">{item?.time}</span>
                            </span>
                            {item?.gCalendarLink && (
                              <a
                                href={item?.gCalendarLink}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <Image
                                  src={appIcons.googleCalendar}
                                  alt="g-calendar"
                                />{" "}
                                Google Calendar
                              </a>
                            )}
                            {item?.msCalendarLink && (
                              <a
                                href={item?.msCalendarLink}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <Image
                                  src={appIcons.outlookCalendar}
                                  alt="ms-calendar"
                                />
                                Microsoft Outlook
                              </a>
                            )}
                            {item?.macCalendarLink && (
                              <a
                                href={item?.macCalendarLink}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <Image src={appIcons.mac} alt="mac-calendar" />
                                Mac
                              </a>
                            )}
                          </li>
                        ))}
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            )}

          <ExploreKanha />
          <Heartintune />
        </div>
      </Layout>
    </>
  );
};

export default SpecialEvent2;
